import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Hero from '../components/Hero/hero';
import Services from '../components/services/Services';
import ContactUs from '../components/contactUs/ContactUs';
import AboutUs from '../components/About/About';
import About1 from '../components/About1/About1';

export default function Home() {
  const { i18n } = useTranslation();
  const en = i18n.language.startsWith('en');
  const [showScrollToTop, setShowScrollToTop] = useState(false);
  useEffect(() => {
    const onScroll = () => setShowScrollToTop(window.scrollY > 600);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return (
    <main id="main-content">
      <div id="home"><Hero /></div>
      <div id="services"><Services /></div>
      <section className="printing-feature" aria-labelledby="printing-feature-title">
        <div className="printing-feature-image">
          <img src="/images/3d-printing-parts.webp" srcSet="/images/3d-printing-parts-640.webp 640w, /images/3d-printing-parts.webp 1400w" sizes="(max-width: 760px) calc(100vw - 40px), (max-width: 1240px) calc(50vw - 24px), 600px" width="1400" height="933" loading="lazy" alt={en ? 'Illustrative 3D printed enclosure and prototype parts' : 'Illustration av 3D-utskrivet hölje och prototypdelar'} />
          <span>{en ? 'Illustrative examples' : 'Illustrativa exempel'}</span>
        </div>
        <div className="printing-feature-copy">
          <span className="eyebrow">{en ? 'FROM IDEA TO PHYSICAL PART' : 'FRÅN IDÉ TILL FYSISK DEL'}</span>
          <h2 id="printing-feature-title">{en ? 'Bring your idea into the real world.' : 'Ge din idé en fysisk form.'}</h2>
          <p>{en ? 'A prototype, a custom enclosure or a part made for your project. Tell us what you need and we will explore how 3D printing can help.' : 'En prototyp, ett anpassat hölje eller en del för ditt projekt. Berätta vad du behöver, så undersöker vi hur 3D-utskrift kan hjälpa dig.'}</p>
          <Link className="site-button" to="/3d-printing">{en ? 'Explore 3D printing' : 'Upptäck 3D-utskrift'} <span aria-hidden="true">↗</span></Link>
          <Link className="text-link" to="/3d-printing#printing-contact">{en ? 'Have a question? Ask us' : 'Har du en fråga? Hör av dig'} →</Link>
        </div>
      </section>
      <div id="about"><AboutUs /><About1 /></div>
      <div id="contact"><ContactUs border /></div>
      {showScrollToTop && <button className="back-to-top" aria-label={en ? 'Back to top' : 'Till toppen'} onClick={() => window.scrollTo({ top: 0, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' })}>↑</button>}
    </main>
  );
}
